/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Not_FoundInputs */

const en_project_not_found = /** @type {(inputs: Project_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not find that piece of work.`)
};

const lv_project_not_found = /** @type {(inputs: Project_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šādu darbu neizdevās atrast.`)
};

/**
* | output |
* | --- |
* | "We could not find that piece of work." |
*
* @param {Project_Not_FoundInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_not_found = /** @type {((inputs?: Project_Not_FoundInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Not_FoundInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_not_found(inputs)
	return en_project_not_found(inputs)
});